<div class="opportunity pt-0">
    <div class="d-flex justify-content-between align-items-center">
        <h3 class="heading mb-0 mt-2">{{ isGallery ? 'Gallery' : 'Files' }}</h3>
    </div>
    <div class="opportunity-list">
        <div *ngIf="!isGallery;else gotoGallery">
            <div class="" *ngIf="(fileList && fileList.length) || (formData && formData?.length); else noDataFound">
                <div class="imageContainer">
                    <div class="d-flex flex-wrap r-gap">
                        <div class="imageDiv" *ngFor="let item of fileList; let i = index;">
                            <img [src]="item" alt="" *ngIf="isImage(item)" (click)="openFileViewer(item)"
                                [matTooltip]="extractName(item)" matTooltipPosition="above" matTooltipShowDelay="500">

                            <!-- pdf -->
                            <img *ngIf="isPdf(item)" [src]="pdfMap.get(item)" alt="PDF Preview"
                                (click)="downloadPdf(item)" [matTooltip]="extractName(item)">
                        </div>
                        <div class="imageDiv" *ngFor="let item of formData">
                            <img src="assets/images/file_copy.svg" alt="" (click)="formViewer(item)"
                                matTooltip="{{ item?.formName }}" matTooltipPosition="above" matTooltipShowDelay="500">
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataFound>
                <div class="no-data">No file Found.</div>
            </ng-template>
        </div>
        <ng-template #gotoGallery>
            <div *ngIf="galleryImages && galleryImages.length">
                <div class="imageContainer">
                    <div class="imageDiv" *ngFor="let item of galleryImages; let i = index;">
                        <div *ngIf="item?.image;else videosTemp">
                            <img [src]="item?.image" alt="" (click)="openFileViewer(item?.image)"
                                [matTooltip]="item?.uniqueName">
                        </div>
                        <ng-template #videosTemp>
                            <video muted [matTooltip]="item?.uniqueName" (click)="openFileViewer(item)">
                                <source [src]="item?.video" type="video/mp4">
                                Your browser does not support HTML video.
                            </video>
                        </ng-template>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- ng-image-fullscreen-view  -->
        <!-- <ng-image-fullscreen-view [images]="galleryImages" [imageIndex]="currentIndex" [show]="showFlag"
            (close)="closeEventHandler()"></ng-image-fullscreen-view>
        <ng-template #noImageFound>
            <div class="no-data">No media found.</div>
        </ng-template> -->
    </div>
</div>